import React from "react";
import "./AutomationCard.css";
import { MdLightbulbOutline } from "react-icons/md";
import Button from "../Button/Button";

const AutomationCard = (props) => {
  return (
    <div className="automation-card-container">
      <div style={{ display: "flex", alignItems: "center" }}>
        <MdLightbulbOutline size={20} color={"#3D4D59"} />
        <h1 className="automation-card-title">
          {props.automation.automation_description}
        </h1>
      </div>
      <div style={{ display: "flex" }}>
        <Button
          label={"Ligar"}
          className={"button-blue automation-card-button"}
          //onClick={handleTurnOn}
        />
        <Button
          label={"Desligar"}
          className={"button-white automation-card-button"}
          //onClick={handleTurnOff}
        />
      </div>
    </div>
  );
};

export default AutomationCard;
